

















import Vue from "vue";

export default Vue.extend({
  name: "ChartWidget",
  props: {
    width: {
      type: String
    },
    height: {
      type: String
    },
    title: {
      type: String
    },
    data: {
      type: Number
    },
    icon: {
      type: String,
      default: "https://i.imgur.com/RtNYTRi.png"
    },
    unit: {
      type: String
    }
  },
  data() {
    return {
      iconWidget: "https://i.imgur.com/RtNYTRi.png"
    };
  },
  methods: {
    handleError() {
      this.iconWidget = "https://i.imgur.com/RtNYTRi.png";
    }
  },
  created() {
    this.iconWidget = this.icon;
  }
});
